import { ROUTES } from './routes';
import { UI_STRINGS } from './ui-strings';
import type { DashboardConfig, PersonaKey } from '@/lib/types/dashboard.types';

// Startup admin personas carry no subtitle: the old "Manage your startup
// profile, team, and fundraise" named actions the dashboard does not offer
// (UX sheet, StartupAdminVF r9).
export const DASHBOARD_CONFIG: Record<PersonaKey, DashboardConfig> = {
  individual: {
    persona: 'individual',
    welcome: { title: 'Welcome', subtitle: 'Complete your profile to unlock more of the platform.' },
    // Default label only: DashboardPage swaps in the resume wording when a
    // wizard draft exists (createStartupCtaLabel), same as the navbar.
    primaryCta: { label: UI_STRINGS.NAV.CREATE_STARTUP, route: ROUTES.CREATE_STARTUP },
    gates: { showUnlockBanner: true, showCreateStartupCta: true, showInvestorProfileCta: false },
  },
  free_startup_admin: {
    persona: 'free_startup_admin',
    welcome: { title: 'Welcome', subtitle: null },
    primaryCta: { label: 'Update your Startup Profile', route: ROUTES.STARTUP_PROFILE },
    gates: { showUnlockBanner: false, showCreateStartupCta: false, showInvestorProfileCta: false },
  },
  premium_startup_admin: {
    persona: 'premium_startup_admin',
    welcome: { title: 'Welcome', subtitle: null },
    // No 'View Data Room' button (MYN-289): the side column's data-room card
    // (Open Command Center / Explore the Issue Report) is the one way in.
    primaryCta: null,
    gates: { showUnlockBanner: false, showCreateStartupCta: false, showInvestorProfileCta: false },
  },
  startup_member: {
    persona: 'startup_member',
    welcome: { title: 'Welcome', subtitle: 'Your startup workspace and shared resources.' },
    primaryCta: null,
    gates: { showUnlockBanner: false, showCreateStartupCta: false, showInvestorProfileCta: false },
  },
  premium_startup_member: {
    persona: 'premium_startup_member',
    welcome: { title: 'Welcome', subtitle: 'Your startup workspace and shared resources.' },
    // No 'View Data Room' button (MYN-289): the side column's data-room card
    // (Open Command Center / Explore the Issue Report) is the one way in.
    primaryCta: null,
    gates: { showUnlockBanner: false, showCreateStartupCta: false, showInvestorProfileCta: false },
  },
  investor_admin: {
    persona: 'investor_admin',
    welcome: { title: 'Welcome', subtitle: 'Manage your investor profile, team, and deal flow.' },
    primaryCta: null,
    gates: { showUnlockBanner: false, showCreateStartupCta: false, showInvestorProfileCta: true },
  },
  investor_member: {
    persona: 'investor_member',
    welcome: { title: 'Welcome', subtitle: 'Your investor workspace and shared resources.' },
    primaryCta: null,
    gates: { showUnlockBanner: false, showCreateStartupCta: false, showInvestorProfileCta: true },
  },
  trusted_partner_member: {
    persona: 'trusted_partner_member',
    welcome: { title: 'Welcome', subtitle: 'Your partner workspace and shared resources.' },
    primaryCta: null,
    gates: { showUnlockBanner: false, showCreateStartupCta: false, showInvestorProfileCta: false },
  },
  super_admin: {
    persona: 'super_admin',
    welcome: { title: 'Welcome', subtitle: 'Platform overview and administration.' },
    // Opens in a new tab (MYN-281, FR-196): AdminLayout is deliberately
    // separate chrome, so this leaves the dashboard tab untouched rather
    // than retrofitting member nav/footer into the admin shell.
    primaryCta: { label: 'Go to Admin Console', route: ROUTES.ADMIN, openInNewTab: true },
    gates: { showUnlockBanner: false, showCreateStartupCta: false, showInvestorProfileCta: false },
  },
};
